import type { MarketplaceErrorRes } from '@dvb/common';

import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function TaskDetailError({
  error,
}: {
  error: Error | MarketplaceErrorRes;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { description, title } = useMemo(() => {
    if ('code' in error && error.code === 2001) {
      return {
        description: t('notFoundDes', { name: t('task') }),
        title: t('notFound', { name: t('task') }),
      };
    }
    return { description: '', title: '' };
  }, [error, t]);

  return (
    <>
      <HeaderBar
        backBtnHandler={() => navigate({ replace: true, to: '/task' })}
        hasBackBtn
        title={t('taskDetails')}
      />
      <BaseErrorLayout
        className="bg-background w-full"
        description={description}
        title={title}
      />
    </>
  );
}
